/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineComponent } from 'vue';
import { defineModule } from 'direct-vuex';
import { moduleActionContext, moduleGetterContext } from '@/plugins/vuex';
import { tasks } from '@/api';

export interface Task {
  taskId: string;
  status: string;
  url: string;
  appId: string;
  result: string | object;
  resultString: string;
  created: Date;
  checked: Date;
}

export interface TaskState {
  tasks: Task[];
  loadingList: boolean;
  loadingTasks: string[];
  deletingTasks: string[];
  clearingList: boolean;
}

const module = defineModule({
  namespaced: true,
  state: (): TaskState => {
    return {
      tasks: [],
      loadingList: false,
      loadingTasks: [],
      deletingTasks: [],
      clearingList: false,
    };
  },
  getters: {
    totalCount(...args): number {
      const { state } = taskGetterContext(args);
      console.log('getting total count?', state.tasks.length);
      return state.tasks.length;
    },
    runningCount(...args): number {
      const { state } = taskGetterContext(args);
      console.log(
        'getting running count?',
        state.tasks.filter(task => task.status == 'STARTED').length
      );
      return state.tasks.filter(task => task.status == 'STARTED').length;
    },
    tasks(...args): number {
      const { state } = taskGetterContext(args);
      return state.tasks;
      // return state.tasks.map(task => ({
      //   ...task,
      //   created: new Date(task.created),
      //   checked: new Date(task.checked),
      // }));
    },
  },
  mutations: {
    setLoadingList(state, value: boolean) {
      state.loadingList = value;
    },
    setList(state, value: Task[]) {
      state.tasks = value;
    },
    setLoadingTask(state, { id, loading }: { id: string; loading: boolean }) {
      if (loading) {
        if (!state.loadingTasks.includes(id)) {
          state.loadingTasks.push(id);
        }
      } else {
        const index = state.loadingTasks.indexOf(id);
        if (0 <= index) {
          delete state.loadingTasks[index];
        }
      }
    },
    setDeletingTask(
      state,
      { id, deleting }: { id: string; deleting: boolean }
    ) {
      if (deleting) {
        if (!state.deletingTasks.includes(id)) {
          state.deletingTasks.push(id);
        }
      } else {
        const index = state.deletingTasks.indexOf(id);
        if (0 <= index) {
          delete state.deletingTasks[index];
        }
      }
    },
    addTask(state, value: Task) {
      const currentTask = state.tasks.find(task => task.taskId == value.taskId);
      if (currentTask) {
        Object.assign(currentTask, value);
      } else {
        state.tasks.push(value);
      }
    },
  },
  actions: {
    async loadList(context) {
      const { commit } = taskActionContext(context);
      commit.setLoadingList(true);
      const result = await tasks.getTasks();
      commit.setList(result.map(parseTask));
      commit.setLoadingList(false);
    },
    async loadTask(context, id: string) {
      console.log('loadtask dispatched', id);
      const { commit, state } = taskActionContext(context);
      if (state.loadingTasks.includes(id)) {
        // If already loading do nothing
        return;
      }

      commit.setLoadingTask({ id, loading: true });
      const result = await tasks.checkTask(id);
      console.log('got tasks?', result);
      commit.addTask(parseTask(result));
      commit.setLoadingTask({ id, loading: false });
    },
    async deleteTask(context, id: string) {
      const { commit, state } = taskActionContext(context);
      if (state.deletingTasks.includes(id)) {
        // If already loading do nothing
        return;
      }
      commit.setDeletingTask({ id, deleting: true });
      try {
        await tasks.deleteTask(id);
        console.log('befure', state.tasks);
        const updatedList = state.tasks.filter(task => task.taskId != id);
        console.log('after', updatedList);
        commit.setList(updatedList);
      } catch (error) {
        console.error(error);
      }
      commit.setDeletingTask({ id, deleting: false });
    },
    // async clearTasks(context) {},
  },
});

const taskGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, module);
const taskActionContext = (context: any) =>
  moduleActionContext(context, module);

export default module;

function parseTask(task: any) {
  return {
    ...task,
    created: new Date(task.created),
    checked: new Date(task.checked),
    resultString:
      typeof task.result == 'object'
        ? JSON.stringify(task.result, null, 2)
        : task.result,
  };
}
